<template>
  <v-container>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <div><b> Iklan</b></div>
    <br />
    <v-card>
      <v-row class="mx-3 pt-2">
        <v-col cols="12" sm="8" class="d-flex align-center">
          <v-text-field
            :label="'Cari berdasarkan ' + berdasarkan"
            outlined
            dense
            v-if="berdasarkan == 'id'"
            v-model="search"
            @keyup.enter="cariId()"
            :suffix="'| Berdasarkan ' + berdasarkan"
          >
            <template v-slot:append>
              <v-menu down offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </template>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'id'"
                    >Berdasarkan Id</v-list-item
                  >
                </v-list>
                <v-list class="px-4">
                  <v-list-item @click="(berdasarkan = 'pengguna'), getUser()"
                    >Berdasarkan Pengguna</v-list-item
                  >
                </v-list>
              </v-menu>
            </template>
          </v-text-field>
          <v-text-field
            :label="'Cari berdasarkan ' + berdasarkan"
            outlined
            dense
            @click="daftarUser = true"
            @keyup="getUser()"
            @keyup.enter="getDataIklan(), getDataIklanSemua()"
            v-if="berdasarkan == 'pengguna'"
            v-model="search"
            :suffix="'| Berdasarkan ' + berdasarkan"
          >
            <template v-slot:append>
              <v-menu down offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </template>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'id'"
                    >Berdasarkan Id</v-list-item
                  >
                </v-list>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'pengguna'"
                    >Berdasarkan Pengguna</v-list-item
                  >
                </v-list>
              </v-menu>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="4" class="d-flex align-center">
          <v-select
            outlined
            v-if="tab == 'Aktif'"
            :items="inijenisIklan"
            dense
            v-model="jenisIklan"
            single-line
            @change="getDataIklan()"
          ></v-select>
          <v-select
            v-if="tab == 'Beku'"
            outlined
            :items="inijenisIklan"
            dense
            v-model="jenisIklan"
            single-line
            @change="getDataIklanBeku()"
          ></v-select>
          <v-select
            v-if="tab == 'Semua'"
            outlined
            :items="inijenisIklan"
            dense
            v-model="jenisIklan"
            single-line
            @change="getDataIklanSemua()"
          ></v-select>
          <v-select
            v-if="tab == 'Indikasi'"
            outlined
            :items="inijenisIklan"
            dense
            v-model="jenisIklan"
            single-line
            @change="getDataIklanIndikasi()"
          ></v-select>
        </v-col>
        <v-col
          v-if="berdasarkan == 'pengguna' && daftarUser == true"
          cols="12"
          sm="8"
          style="position:absolute;z-index:10"
          class="mt-11"
        >
          <v-list
            elevation="1"
            style="width:90%;height:200px;overflow-y:scroll;"
          >
            <v-list-item class="mb-4">
              <table style="width:100%">
                <tr
                  v-for="(item, i) in iniListUser"
                  :key="i"
                  @click="memilihUser(item)"
                  style="cursor:pointer"
                >
                  <td style="width:70px">
                    <v-avatar>
                      <v-img src="img/beat.png"></v-img>
                    </v-avatar>
                  </td>
                  <td>{{ item.nama }}</td>
                  <td class="text-right">
                    <v-icon>
                      mdi-chevron-right
                    </v-icon>
                  </td>
                </tr>
              </table>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <div class="d-flex ml-6">
        <div
          :style="
            tab == 'Semua'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2"
          @click="tabIklan('Semua')"
        >
          Semua({{ totalIklanSemua }})
        </div>
        <div
          :style="
            tab == 'Aktif'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Aktif')"
        >
          Aktif({{ totalIklanAktif }})
        </div>
        <div
          :style="
            tab == 'Laporan'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Laporan')"
        >
          Laporan Pengguna({{ totalIklanDilaporkan }})
        </div>
        <div
          :style="
            tab == 'Dipantau'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Dipantau')"
        >
          Dipantau({{ totalIklanDipantau }})
        </div>
        <div
          :style="
            tab == 'Beku'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Beku')"
        >
          Dibekukan({{ totalIklanBeku }})
        </div>
        <div
          :style="
            tab == 'Indikasi'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Indikasi')"
        >
          Indikasi({{ totalIklanIndikasi }})
        </div>
      </div>
      <br /><br />
      <div v-if="tab == 'Semua'">
        <v-data-table
          show-select
          v-model="selectedSemua"
          :headers="headersSemua"
          :items="listIklanSemua"
          hide-default-footer
          class="elevation-1"
          :loading="loadingIklanSemua"
        >
          <template v-slot:[`item.nama_penjual`]="{ item }">
            <div>{{ item._source.app_user }}</div>
          </template>
          <template v-slot:[`item.iklan`]="{ item }">
            <div
              class="d-flex"
              @click="go('semua', item)"
              style="cursor:pointer"
            >
              <!-- <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div> -->
              <div class="my-2">
                <v-img
                  style="border-radius:10px;width:80px;height:80px"
                  :src="$url_img + item._source.photo"
                ></v-img>
              </div>
              <div class="pl-3 py-1">
                <!-- <div class="px-1 py-1 text-center" style="color:#c90000;background:#ffeeee;border-radius:10px;width:60px">Semua</div>  -->
                <div>{{ item._source.judul }}</div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.tipe_iklan`]="{ item }">
            <div v-if="item._source.id_mst_iklan_jenis == 2">
              {{ item._source.mst_iklan_jenis }}
              {{ item._source.mst_iklan_type }} {{ item._source.mst_type_tb }}
            </div>
            <div v-else>{{ item._source.mst_iklan_jenis }}</div>
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageSemua"
                @input="getDataIklanSemua()"
                :length="lengthPageSemua"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab == 'Aktif'">
        <v-data-table
          show-select
          v-model="selectedAktif"
          :headers="headersAktif"
          :items="listIklanAktif"
          item-key="_id"
          hide-default-footer
          class="elevation-1"
          :loading="loadingIklanAktif"
        >
          <!-- <template v-slot:[`item.id`]="{ item }">
                        <div>{{item._source.id}}</div>
                    </template> -->
          <template v-slot:[`item.nama_penjual`]="{ item }">
            <div>{{ item._source.app_user }}</div>
          </template>
          <template v-slot:[`item.iklan`]="{ item }">
            <!-- <table style="width:100%" class="py-1">
                            <tr>
                                <td>
                                    <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div>
                                    <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" :src="$url_img + item._source.photo"></v-img></div>
                                </td>
                                <td class="pl-1">
                                    <div class="px-1 py-1 text-center" style="color:#c90000;background:#ffeeee;border-radius:10px;width:60px">Aktif</div>
                                    <div>{{item._source.deskripsi.substring(0, 140) + '...' }}</div>
                                </td>
                            </tr>
                        </table> -->
            <div
              class="d-flex"
              @click="go('aktif', item)"
              style="cursor:pointer"
            >
              <!-- <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div> -->
              <div class="my-2">
                <v-img
                  style="border-radius:10px;width:80px;height:80px"
                  :src="$url_img + item._source.photo"
                ></v-img>
              </div>
              <div class="pl-3 py-1">
                <div
                  class="px-1 py-1 text-center"
                  style="color:#c90000;background:#ffeeee;border-radius:10px;width:60px"
                >
                  Aktif
                </div>
                <div>{{ item._source.judul }}</div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.tipe_iklan`]="{ item }">
            <div v-if="item._source.id_mst_iklan_jenis == 2">
              {{ item._source.mst_iklan_jenis }}
              {{ item._source.mst_iklan_type }} {{ item._source.mst_type_tb }}
            </div>
            <div v-else>{{ item._source.mst_iklan_jenis }}</div>
          </template>
          <template v-slot:[`item.aksi`]="{ item }">
            <div class="d-flex" style="gap: 5px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="pickIdIklanBekukan(item._source.id)"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    elevation="0"
                    outlined
                    style="border-color:orange;"
                    ><v-icon color="orange">mdi-stop</v-icon></v-btn
                  >
                </template>
                <span>Bekukan</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="pickIdIklanPantau(item._source.id)"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    elevation="0"
                    outlined
                    style="border-color: #c90000;"
                    ><v-icon color="#c90000">mdi-eye-outline</v-icon></v-btn
                  >
                </template>
                <span>Pantau</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="pickIdIklanHapus(item._source.id)"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    elevation="0"
                    outlined
                    style="border-color: red"
                    ><v-icon color="red">mdi-trash-can</v-icon></v-btn
                  >
                </template>
                <span>Hapus</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageAktif"
                @input="getDataIklan()"
                :length="lengthPageAktif"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab == 'Beku'">
        <v-data-table
          :headers="headersBeku"
          hide-default-footer
          :items="listIklanBeku"
          item-key="id_iklan"
          show-select
          class="elevation-1 listdibekukan"
          :loading="loadingIklanBeku"
        >
          <template v-slot:[`item.iklan`]="{ item }">
            <div
              class="d-flex"
              @click="go('beku', item)"
              style="cursor:pointer"
            >
              <div style="width:80px;" class="my-2">
                <v-img
                  style="border-radius:10px"
                  :src="$url_img + item.photo"
                ></v-img>
              </div>
              <!-- <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div> -->
              <div class="pl-3 py-1">
                <div
                  class="px-1 py-1 text-center"
                  style="color:#E9554B;background:#FFF4F2;border-radius:10px;width:80px"
                >
                  Dibekukan
                </div>
                <div style="font-weight:bold">
                  Oleh : {{ item.nama_karyawan }}
                </div>
                <div>{{ item.judul }}</div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.aksi`]="{}">
            <v-btn
              x-small
              elevation="0"
              style="border:1px solid #c90000;color:#c90000"
              >Aktifkan</v-btn
            >
          </template>
          <template v-slot:[`item.tanggal_dibekukan`]="{ item }">
            <div style="font-size:13px">
              {{ item.tanggal_dibekukan | dateTimeFormat }} WIB
            </div>
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageBeku"
                @input="getDataIklanBeku()"
                :length="lengthPageBeku"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab == 'Laporan'">
        <v-data-table
          :headers="headersDilaporkan"
          hide-default-footer
          :items="listIklanDilaporkan"
          item-key="id_iklan"
          class="elevation-1 listdibekukan"
          :loading="loadingIklanDilaporkan"
        >
          <template v-slot:[`item.iklan`]="{ item }">
            <div
              class="d-flex"
              @click="go('laporan', item)"
              style="cursor:pointer"
            >
              <div style="width:80px;" class="my-2">
                <v-img
                  style="border-radius:10px;height:80px"
                  :src="$url_img + item.photo"
                ></v-img>
              </div>
              <div class="pl-3 py-1">
                <!-- <div class="px-1 py-1 text-center" style="color:#E9554B;background:#FFF4F2;border-radius:10px;width:80px">Dibekukan</div> -->
                <!-- <div>Oleh : {{item.nama_karyawan}}</div> -->
                <!-- <div>{{item.judul.substring(0, 140) + '...' }}</div> -->
                <div>{{ item.judul }}</div>
                <div
                  class="px-1 py-1 text-center"
                  style="color:#c90000;background:#ffeeee;font-size:13px;border-radius:10px;width:150px"
                >
                  {{ item.tgl_laporan_terbaru | dateTimeFormat }} WIB
                </div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.aksi`]="{ item }">
            <div>
              <v-icon
                @click="toPantau(item, 'laporan')"
                style="cursor:pointer"
                class="mr-2"
                color="#c90000"
                >mdi-pencil-box-multiple-outline</v-icon
              >
            </div>
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageDilaporkan"
                @input="getDataIklanDilaporkan()"
                :length="lengthPageDilaporkan"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab == 'Dipantau'">
        <v-data-table
          :headers="headersDipantau"
          hide-default-footer
          :items="listIklanDipantau"
          item-key="id_iklan"
          class="elevation-1 listdibekukan"
          :loading="loadingIklanDipantau"
        >
          <template v-slot:[`item.iklan`]="{ item }">
            <div
              class="d-flex"
              @click="go('dipantau', item)"
              style="cursor:pointer"
            >
              <div style="width:80px;" class="my-2">
                <v-img
                  style="border-radius:10px;height:80px"
                  :src="$url_img + item.photo"
                ></v-img>
              </div>
              <div class="pl-3 py-1">
                <!-- <div class="px-1 py-1 text-center" style="color:#E9554B;background:#FFF4F2;border-radius:10px;width:80px">Dibekukan</div> -->
                <!-- <div>Oleh : {{item.nama_karyawan}}</div> -->
                <div>{{ item.judul }}</div>
                <!-- <div>{{item.judul}}</div> -->
                <div
                  class="px-1 py-1 text-center"
                  style="color:#c90000;background:#ffeeee;font-size:13px;border-radius:10px;width:150px"
                >
                  {{ item.created_at | dateTimeFormat }} WIB
                </div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.aksi`]="{ item }">
            <div>
              <v-icon
                @click="toPantau(item, 'pantau')"
                style="cursor:pointer"
                class="mr-2"
                color="#c90000"
                >mdi-pencil-box-multiple-outline</v-icon
              >
            </div>
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageDipantau"
                @input="getDataIklanDipantau()"
                :length="lengthPageDipantau"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab == 'Indikasi'">
        <v-data-table
          :headers="headersIndikasi"
          v-model="selectedAktif"
          show-select
          hide-default-footer
          :items="listIklanIndikasi"
          item-key="id"
          class="elevation-1 listdibekukan"
          :loading="loadingIklanIndikasi"
        >
          <template v-slot:[`item.iklan`]="{ item }">
            <div
              class="d-flex"
              @click="go('dipantau', item)"
              style="cursor:pointer"
            >
              <div style="width:80px;" class="my-2">
                <v-img
                  style="border-radius:10px;height:80px"
                  :src="$url_img + item.photo"
                ></v-img>
              </div>
              <div class="pl-3 py-1">
                <!-- <div class="px-1 py-1 text-center" style="color:#E9554B;background:#FFF4F2;border-radius:10px;width:80px">Dibekukan</div> -->
                <!-- <div>Oleh : {{item.nama_karyawan}}</div> -->
                <div>{{ item.judul }}</div>
                <!-- <div>{{item.judul}}</div> -->
                <div
                  class="px-1 py-1 text-center"
                  style="color:#c90000;background:#ffeeee;font-size:13px;border-radius:10px;width:150px"
                >
                  {{ item.sumber }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.aksi`]="{ item }">
            <v-btn
              @click="pickIdIklanBekukan(item.id_iklan)"
              x-small
              elevation="0"
              style="width:70px;border:1px solid #E9554B;color:#E9554B"
              >Bekukan</v-btn
            >
            <v-btn
              @click="pickIdIklanPantau(item.id_iklan)"
              x-small
              elevation="0"
              style="width:70px;border:1px solid #B79674;color:#B79674"
              >Pantau</v-btn
            >
            <v-btn
              @click="pickIdIklanNormal(item.id_iklan)"
              x-small
              elevation="0"
              style="width:70px;border:1px solid #c90000;color:#c90000"
              >Normal</v-btn
            >
          </template>
        </v-data-table>
        <br />
        <v-row>
          <v-col cols="10" md="12">
            <div class="text-center pt-2">
              <v-pagination
                color="#c90000"
                v-model="pageIndikasi"
                @input="getDataIklanIndikasi()"
                :length="lengthPageIndikasi"
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <br /><br /><br /><br />
    <v-card
      style="position: fixed; bottom: 0"
      class="py-5"
      width="77.5%"
      elevation="5"
      v-if="tab == 'Aktif'"
    >
      <v-row>
        <v-col cols="12" sm="9">
          <div class="ml-6 mt-2" style="font-size:20px">
            {{ selectedAktif.length }} Iklan Terpilih
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            :disabled="selectedAktif.length > 0 ? false : true"
            style="border:2px solid #E9554B;color:#E9554B"
            @click="(dialogBekukan = true), (optionBekukan = 'banyak')"
          >
            Bekukan
          </v-btn>
          <v-btn
            class="mx-1"
            :disabled="selectedAktif.length > 0 ? false : true"
            style="border:2px solid #c90000;color:#c90000"
            @click="(dialogPantau = true), (optionPantau = 'banyak')"
          >
            Pantau
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      style="position: fixed; bottom: 0"
      class="py-5"
      width="77.5%"
      elevation="5"
      v-if="tab == 'Indikasi'"
    >
      <v-row>
        <v-col cols="12" sm="7">
          <div class="ml-6 mt-2" style="font-size:20px">
            {{ selectedAktif.length }} Iklan Terpilih
          </div>
        </v-col>
        <v-col cols="12" sm="5">
          <v-btn
            :disabled="selectedAktif.length > 0 ? false : true"
            small
            style="border:2px solid #E9554B;color:#E9554B"
            @click="(dialogBekukan = true), (optionBekukan = 'banyak')"
          >
            Bekukan
          </v-btn>
          <v-btn
            class="mx-1"
            :disabled="selectedAktif.length > 0 ? false : true"
            small
            style="border:2px solid #B79674;color:#B79674"
            @click="(dialogPantau = true), (optionPantau = 'banyak')"
          >
            Pantau
          </v-btn>
          <v-btn
            class="mx-1"
            :disabled="selectedAktif.length > 0 ? false : true"
            small
            style="border:2px solid #c90000;color:#c90000"
            @click="(dialogNormal = true), (optionNormal = 'banyak')"
          >
            Normal
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogBekukan" max-width="600px">
      <v-card>
        <v-toolbar flat dense color="#c90000">
          <v-toolbar-title dark><b>Pembekuan Iklan </b></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialogBekukan = false), (alasan = '')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br />
        <div class="mx-3">
          <h3>Masukkan alasan mengapa iklan dibekukan</h3>
          <v-textarea solo label="Alasan" v-model="alasan"></v-textarea>
        </div>
        <v-card-actions>
          <v-spacer />

          <v-btn
            dense
            small
            outlined
            @click="(dialogBekukan = false), (alasan = '')"
          >
            cancel
          </v-btn>
          <v-btn
            @click="bekukanIklan()"
            dense
            small
            color="#c90000"
            :disabled="alasan == '' ? true : false"
          >
            Bekukan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPantau" max-width="600px">
      <v-card>
        <v-toolbar flat dense color="#c90000">
          <v-toolbar-title dark><b>Pemantauan Iklan </b></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialogPantau = false), (alasan = '')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br />
        <div class="mx-3">
          <h3>Masukkan alasan mengapa iklan dipantau</h3>
          <v-textarea solo label="Alasan" v-model="alasan"></v-textarea>
        </div>
        <v-card-actions>
          <v-spacer />

          <v-btn
            dense
            small
            outlined
            @click="(dialogPantau = false), (alasan = '')"
          >
            cancel
          </v-btn>
          <v-btn
            @click="pantauIklan()"
            dense
            small
            color="#c90000"
            :disabled="alasan == '' ? true : false"
          >
            Pantau
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHapus" max-width="600px">
      <v-card>
        <v-toolbar flat dense color="#c90000">
          <v-toolbar-title dark><b>Hapus Iklan </b></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialogHapus = false), (alasan = '')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br />
        <div class="mx-3">
          <h3>Masukkan alasan mengapa iklan dihapus</h3>
          <v-textarea solo label="Alasan" v-model="alasan"></v-textarea>
        </div>
        <v-card-actions>
          <v-spacer />

          <v-btn
            dense
            small
            outlined
            @click="(dialogHapus = false), (alasan = '')"
          >
            cancel
          </v-btn>
          <v-btn
            @click="hapusIklan()"
            dense
            small
            color="#c90000"
            :disabled="alasan == '' ? true : false"
          >
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNormal" max-width="600px">
      <v-card>
        <v-toolbar flat dense color="#c90000">
          <v-toolbar-title dark><b>Normalkan Iklan</b></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialogNormal = false), (alasan = '')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br />
        <div class="mx-3">
          <h3>Masukkan alasan mengapa iklan ini normal</h3>
          <v-textarea solo label="Alasan" v-model="alasan"></v-textarea>
        </div>
        <v-card-actions>
          <v-spacer />

          <v-btn
            dense
            small
            outlined
            @click="(dialogNormal = false), (alasan = '')"
          >
            cancel
          </v-btn>
          <v-btn
            @click="normalIklan()"
            dense
            small
            color="#c90000"
            :disabled="alasan == '' ? true : false"
          >
            Normal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import 'firebase/firestore';
import moment from 'moment-timezone';
export default {
  name: 'ListIklan',
  data: () => ({
    color: { snackbar: '' },
    snackbar: false,
    message: null,
    berdasarkan: 'id',
    search: '',
    inijenisIklan: ['Semua','Lelang'],
    jenisIklan: 'Semua',
    daftarUser: false,
    iniListUser: [],
    pickIdUser: '',
    tab: 'Semua',
    alasan: '',
    headersAktif: [
      { text: 'Id iklan', value: '_id' },
      { text: 'Nama Penjual', value: 'nama_penjual' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'tipe_iklan' },
      { text: 'Aksi', value: 'aksi' }
    ],
    headersIndikasi: [
      { text: 'Id iklan', value: 'id_iklan' },
      { text: 'Nama Penjual', value: 'nama_user' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'jenis' },
      { text: 'Alasan', value: 'alasan' },
      { text: 'Aksi', value: 'aksi' }
    ],
    headersSemua: [
      { text: 'Id iklan', value: '_id' },
      { text: 'Nama Penjual', value: 'nama_penjual' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'tipe_iklan' }
    ],
    headersBeku: [
      { text: 'Id iklan', value: 'id_iklan' },
      { text: 'Nama Penjual', value: 'nama_user' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'jenis' },
      { text: 'Tanggal Dibekukan', value: 'tanggal_dibekukan' },
      { text: 'Alasan Dibekukan', value: 'alasan' },
      { text: 'Aksi', value: 'aksi' }
    ],
    headersDilaporkan: [
      { text: 'Id iklan', value: 'id_iklan' },
      { text: 'Nama Penjual', value: 'nama_user' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'jenis' },
      { text: 'Aksi', value: 'aksi' },
      { text: 'Total Laporan', value: 'total_laporan' }
    ],
    headersDipantau: [
      { text: 'Id iklan', value: 'id_iklan' },
      { text: 'Nama Penjual', value: 'nama_user' },
      { text: 'Iklan', value: 'iklan' },
      { text: 'Tipe Iklan', value: 'jenis' },
      { text: 'Aksi', value: 'aksi' }
    ],
    iklanBekukan: [
      {
        id: 1234,
        nama_penjual: 'Clief',
        tipe_iklan: 'iklan baris',
        oleh: 'deni',
        tanggal_dibekukan: '04 Mar 2021 10.20 WIB',
        alasan_dibekukan: 'tipu tipu'
      },
      {
        id: 4321,
        nama_penjual: 'Benyal',
        tipe_iklan: 'iklan_baris',
        oleh: 'candra',
        tanggal_dibekukan: '04 Mar 2021 10.20 WIB',
        alasan_dibekukan: 'boongan'
      }
    ],
    dialogBekukan: false,
    dialogPantau: false,
    dialogNormal: false,
    dialogHapus: false,
    idAdmin: '',
    idIklanDibekukan: '',
    optionBekukan: '',
    idIklanDipantau: '',
    optionPantau: '',
    idIklanNormal: '',
    optionNormal: '',
    idIklanDhapus: '',
    optionHapus: '',

    listIklanAktif: [],
    totalIklanAktif: 0,
    limitAktif: 10,
    pageAktif: 1,
    offsetAktif: 0,
    totalAktif: 0,
    lengthPageAktif: 0,
    countIklanAktif: '',
    selectedAktif: [],
    loadingIklanAktif: false,

    listIklanBeku: [],
    totalIklanBeku: 0,
    limitBeku: 10,
    pageBeku: 1,
    offsetBeku: 0,
    totalBeku: 0,
    lengthPageBeku: 0,
    countIklanBeku: '',
    selectedBeku: [],
    loadingIklanBeku: false,

    listIklanSemua: [],
    totalIklanSemua: 0,
    limitSemua: 10,
    pageSemua: 1,
    offsetSemua: 0,
    totalSemua: 0,
    lengthPageSemua: 0,
    countIklanSemua: '',
    selectedSemua: [],
    loadingIklanSemua: false,

    listIklanDilaporkan: [],
    totalIklanDilaporkan: 0,
    limitDilaporkan: 10,
    pageDilaporkan: 1,
    offsetDilaporkan: 0,
    totalDilaporkan: 0,
    lengthPageDilaporkan: 0,
    countIklanDilaporkan: '',
    loadingIklanDilaporkan: false,

    listIklanDipantau: [],
    totalIklanDipantau: 0,
    limitDipantau: 10,
    pageDipantau: 1,
    offsetDipantau: 0,
    totalDipantau: 0,
    lengthPageDipantau: 0,
    countIklanDipantau: '',
    loadingIklanDipantau: false,

    listIklanIndikasi: [],
    totalIklanIndikasi: 0,
    limitIndikasi: 10,
    pageIndikasi: 1,
    offsetIndikasi: 0,
    totalIndikasi: 0,
    lengthPageIndikasi: 0,
    countIklanIndikasi: '',
    loadingIklanIndikasi: false
  }),
  methods: {
    async getUser() {
      if (this.berdasarkan != 'id') {
        let params = new URLSearchParams();

        params.set('limit', 20);

        if (this.search != '') {
          params.set('search', this.search);
        }

        let request = {
          params: params
        };
        await this.$req
          .get(this.$root.$baseapi.user + '/user/v3/user', request)
          .then(response => {
            this.iniListUser = response.data.data;
            console.log('data user', this.iniListUser);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async cariId() {
      if (this.tab == 'Semua') {
        this.getDataIklanSemua();
      } else if (this.tab == 'Aktif') {
        this.getDataIklan();
      }
    },
    async memilihUser(item) {
      this.pickIdUser = item.id;
      this.search = item.nama;
      this.daftarUser = false;
      if (this.tab == 'Semua') {
        this.getDataIklanSemua();
      } else if (this.tab == 'Aktif') {
        this.getDataIklan();
      }
    },
    async tabIklan(data) {
      if (data == 'Aktif') {
        this.$router.push('/list_iklan?tab=aktif');
        this.tab = 'Aktif';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklan();
      }
      if (data == 'Laporan') {
        this.$router.push('/list_iklan?tab=laporan');
        this.tab = 'Laporan';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklanDilaporkan();
      }
      if (data == 'Dipantau') {
        this.$router.push('/list_iklan?tab=dipantau');
        this.tab = 'Dipantau';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklanDipantau();
      }
      if (data == 'Beku') {
        this.$router.push('/list_iklan?tab=beku');
        this.tab = 'Beku';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklanBeku();
      }
      if (data == 'Indikasi') {
        this.$router.push('/list_iklan?tab=indikasi');
        this.tab = 'Indikasi';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklanIndikasi();
      }
      if (data == 'Semua') {
        this.$router.push('/list_iklan?tab=semua');
        this.tab = 'Semua';
        this.jenisIklan = 'Semua';
        this.search = '';
        this.selectedAktif = [];
        this.getDataIklanSemua();
      }
    },
    async getDataIklan() {
      this.loadingIklanAktif = true;
      let offset = (this.pageAktif - 1) * this.limitAktif;
      let params = new URLSearchParams();

      params.set('id_mst_iklan_status', 1);
      params.set('limit', this.limitAktif);
      params.set('offset', offset);
      if (this.jenisIklan == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenisIklan == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenisIklan == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.search + '/search/v3/search', request)
        .then(response => {
          let data = response.data;

          let { hits } = data.hits;
          if (hits != null) {
            this.listIklanAktif = hits;

            // this.totalAktif = data.hits.total.value
            // this.lengthPageAktif = Math.ceil(this.totalAktif / this.limitAktif)
            // this.pageAktif++
            // this.countIklanAktif = response.data.hits.total.value
            var mod = response.data.hits.total.value % this.limitAktif;
            this.totalIklanAktif = response.data.hits.total.value;
            var lengthPage = 0;

            lengthPage =
              (response.data.hits.total.value - mod) / this.limitAktif;

            if (mod == 0) {
              this.lengthPageAktif = lengthPage;
            } else {
              this.lengthPageAktif = lengthPage + 1;
            }
          }
          this.daftarUser = false;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanAktif = false;
        });
    },
    async getDataIklanBeku() {
      this.loadingIklanBeku = true;
      let offset = (this.pageBeku - 1) * this.limitBeku;
      let params = new URLSearchParams();

      params.set('id_mst_iklan_status', 1);
      params.set('limit', this.limitBeku);
      params.set('offset', offset);
      if (this.jenisIklan == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenisIklan == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenisIklan == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(
          this.$root.$baseapi.iklan + '/iklan/v3/list_take_down_iklan',
          request
        )
        .then(response => {
          this.listIklanBeku = response.data.data;
          if (this.listIklanBeku != null) {
            var mod = response.data.count % this.limitBeku;
            var lengthPage = 0;

            lengthPage = (response.data.count - mod) / this.limitBeku;
            this.totalIklanBeku = response.data.count;

            if (mod == 0) {
              this.lengthPageBeku = lengthPage;
            } else {
              this.lengthPageBeku = lengthPage + 1;
            }
            this.daftarUser = false;
          }
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanBeku = false;
        });
    },
    async getDataIklanIndikasi() {
      let offset = (this.pageIndikasi - 1) * this.limitIndikasi;
      let params = new URLSearchParams();
      this.loadingIklanIndikasi = true;

      params.set('id_mst_iklan_status', 1);
      params.set('limit', this.limitIndikasi);
      params.set('offset', offset);
      if (this.jenisIklan == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenisIklan == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenisIklan == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(
          this.$root.$baseapi.iklan + '/iklan/v3/iklan_indikasi_penipuan',
          request
        )
        .then(response => {
          this.listIklanIndikasi = response.data.data;
          if (this.listIklanIndikasi != null) {
            var mod = response.data.count % this.limitIndikasi;
            var lengthPage = 0;

            lengthPage = (response.data.count - mod) / this.limitIndikasi;
            this.totalIklanIndikasi = response.data.count;

            if (mod == 0) {
              this.lengthPageIndikasi = lengthPage;
            } else {
              this.lengthPageIndikasi = lengthPage + 1;
            }
            this.daftarUser = false;
          }
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanIndikasi = false;
        });
    },
    async getDataIklanSemua() {
      let offset = (this.pageSemua - 1) * this.limitSemua;
      let params = new URLSearchParams();
      this.loadingIklanSemua = true;

      params.set('limit', this.limitSemua);
      params.set('offset', offset);
      if (this.jenisIklan == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenisIklan == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenisIklan == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.search + '/search/v4/search', request)
        .then(response => {
          console.log(response);

          if (response.data.hits.hits != null) {
            this.listIklanSemua = response.data.hits.hits;
            var mod = response.data.hits.total.value % this.limitSemua;
            var lengthPage = 0;

            lengthPage =
              (response.data.hits.total.value - mod) / this.limitSemua;
            this.totalIklanSemua = response.data.hits.total.value;

            if (mod == 0) {
              this.lengthPageSemua = lengthPage;
            } else {
              this.lengthPageSemua = lengthPage + 1;
            }
            this.daftarUser = false;
          }
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanSemua = false;
        });
    },
    async getDataIklanDilaporkan() {
      this.loadingIklanDilaporkan = true;
      let offset = (this.pageDilaporkan - 1) * this.limitDilaporkan;
      let params = new URLSearchParams();

      // params.set('id_mst_iklan_status', 1)
      params.set('limit', this.limitDilaporkan);
      params.set('offset', offset);
      if (this.jenisIklan == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenisIklan == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenisIklan == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(
          this.$root.$baseapi.iklan + '/iklan/v3/list_laporan_iklan',
          request
        )
        .then(response => {
          this.listIklanDilaporkan = response.data.data;
          if (this.listIklanDilaporkan != null) {
            var mod = response.data.count % this.limitDilaporkan;
            var lengthPage = 0;

            lengthPage = (response.data.count - mod) / this.limitDilaporkan;
            this.totalIklanDilaporkan = response.data.count;
            if (mod == 0) {
              this.lengthPageDilaporkan = lengthPage;
            } else {
              this.lengthPageDilaporkan = lengthPage + 1;
            }
            this.daftarUser = false;
          }
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanDilaporkan = false;
        });
    },
    async getDataIklanDipantau() {
      this.loadingIklanDipantau = true;
      let offset = (this.pageDipantau - 1) * this.limitDipantau;
      let params = new URLSearchParams();

      // params.set('id_mst_iklan_status', 1)
      params.set('limit', this.limitDipantau);
      params.set('offset', offset);
      // if (this.jenisIklan == "Iklan Baris") {
      //     params.set('id_mst_iklan_jenis', 1)
      // }
      // if (this.jenisIklan == "Tawar Bersama") {
      //     params.set('id_mst_iklan_jenis', 2)
      // }
      // if (this.jenisIklan == "Aksesoris dan Suku Cadang") {
      //     params.set('id_mst_iklan_jenis', 5)
      // }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.iklan + '/iklan/v3/list_pantau_iklan', request)
        .then(response => {
          // let data = response.data
          // let { hits } = data.hits
          this.listIklanDipantau = response.data.data;
          if (this.listIklanDipantau != null) {
            // this.totalAktif = data.hits.total.value
            // this.lengthPageAktif = Math.ceil(this.totalAktif / this.limitAktif)
            // this.pageAktif++
            // this.countIklanAktif = response.data.hits.total.value
            var mod = response.data.count % this.limitDipantau;
            var lengthPage = 0;

            lengthPage = (response.data.count - mod) / this.limitDipantau;
            this.totalIklanDipantau = response.data.count;

            if (mod == 0) {
              this.lengthPageDipantau = lengthPage;
            } else {
              this.lengthPageDipantau = lengthPage + 1;
            }
            this.daftarUser = false;
            console.log('data Iklan Dipantau', this.listIklanDipantau);
          }
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        })
        .finally(() => {
          this.loadingIklanDipantau = false;
        });
    },
    async getDataIklanPush() {
      let offset = (this.page - 1) * this.limit;
      let params = new URLSearchParams();

      params.set('id_mst_iklan_status', 1);
      params.set('limit', this.limit);
      params.set('offset', offset);
      if (this.jenis == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenis == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenis == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }
      if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.search);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.search + '/search/v3/search', request)
        .then(response => {
          let data = response.data;
          let { hits } = data.hits;
          this.dataIklan.push(...hits);
          for (let i = 0; i < this.dataIklan.length; i++) {
            if (this.dataIklan[i]._score == null) {
              this.dataIklan[i]._score = false;
            } else if (this.dataIklan[i]._score == false) {
              this.dataIklan[i]._score = false;
            } else if (this.dataIklan[i]._score == true) {
              this.dataIklan[i]._score = true;
            }
          }

          this.total = data.hits.total.value;
          this.lengthPage = Math.ceil(this.total / this.limit);
          this.page++;
          this.countIklan = response.data.hits.total.value;
          console.log('total', this.dataIklan);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async test() {
      console.log('select', this.selectedAktif);
    },
    async pickIdIklanBekukan(id) {
      this.optionBekukan = 'satuan';
      this.idIklanDibekukan = id;
      this.dialogBekukan = true;
    },
    async pickIdIklanNormal(id) {
      this.optionNormal = 'satuan';
      this.idIklanNormal = id;
      this.dialogNormal = true;
    },
    async pickIdIklanPantau(id) {
      this.optionPantau = 'satuan';
      this.idIklanDipantau = id;
      this.dialogPantau = true;
    },
    async pickIdIklanHapus(id) {
      this.optionHapus = 'satuan';
      this.idIklanDihapus = id;
      this.dialogHapus = true;
    },

    async bekukanIklan() {
      let formData = new FormData();
      formData.append('id_biz_user', this.idAdmin);
      formData.append('alasan', this.alasan);
      if (this.optionBekukan == 'satuan') {
        formData.append('id_iklan', this.idIklanDibekukan);
      } else if (this.optionBekukan == 'banyak') {
        for (let i = 0; i < this.selectedAktif.length; i++) {
          if (this.$route.query.tab == 'indikasi') {
            formData.append('id_iklan', this.selectedAktif[i].id_iklan);
          } else {
            formData.append('id_iklan', this.selectedAktif[i]._source.id);
          }
        }
      }

      this.$req
        .post(this.$root.$baseapi.iklan + '/iklan/v3/take_down_iklan', formData)
        .then(response => {
          this.alasan = '';
          this.dialogBekukan = false;
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
          this.selectedAktif = [];
          this.getDataIklan();
          this.getDataIklanIndikasi();
        })
        .catch(error => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
          console.log(responses);
        });
    },
    async normalIklan() {
      let formData = new FormData();
      formData.append('id_biz_user', this.idAdmin);
      formData.append('alasan', this.alasan);
      if (this.optionNormal == 'satuan') {
        formData.append('id_iklan', this.idIklanNormal);
      } else if (this.optionNormal == 'banyak') {
        for (let i = 0; i < this.selectedAktif.length; i++) {
          if (this.$route.query.tab == 'indikasi') {
            formData.append('id_iklan', this.selectedAktif[i].id_iklan);
          } else {
            formData.append('id_iklan', this.selectedAktif[i]._source.id);
          }
        }
      }

      this.$req
        .post(
          this.$root.$baseapi.iklan +
            '/iklan/v3/iklan_indikasi_penipuan_status_normal',
          formData
        )
        .then(response => {
          this.alasan = '';
          this.dialogNormal = false;
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
          this.selectedAktif = [];
          this.getDataIklanIndikasi();
          // this.getDataIklan()
        })
        .catch(error => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
          console.log(responses);
        });
    },
    async pantauIklan() {
      let formData = new FormData();
      formData.append('id_biz_user', this.idAdmin);
      formData.append('alasan', this.alasan);
      if (this.optionPantau == 'satuan') {
        formData.append('id_iklan', this.idIklanDipantau);
      } else if (this.optionPantau == 'banyak') {
        for (let i = 0; i < this.selectedAktif.length; i++) {
          if (this.$route.query.tab == 'indikasi') {
            formData.append('id_iklan', this.selectedAktif[i].id_iklan);
          } else {
            formData.append('id_iklan', this.selectedAktif[i]._source.id);
          }
        }
      }

      this.$req
        .post(
          this.$root.$baseapi.iklan + '/iklan/v3/pantau_iklan_status',
          formData
        )
        .then(response => {
          this.alasan = '';
          this.dialogPantau = false;
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
          this.selectedAktif = [];
          this.getDataIklan();
          this.getDataIklanDipantau();
          this.getDataIklanIndikasi();
        })
        .catch(error => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
          console.log(responses);
        });
    },

    async hapusIklan() {
      let formData = new FormData();
      // formData.append('id_biz_user', this.idAdmin);
      // formData.append('alasan', this.alasan);
      formData.append('note', this.alasan);
      if (this.optionHapus == 'satuan') {
        // formData.append('id_iklan', this.idIklanDihapus);
        formData.append('id', this.idIklanDihapus);
      } else if (this.optionHapus == 'banyak') {
        for (let i = 0; i < this.selectedAktif.length; i++) {
          if (this.$route.query.tab == 'indikasi') {
            formData.append('id_iklan', this.selectedAktif[i].id_iklan);
          } else {
            formData.append('id_iklan', this.selectedAktif[i]._source.id);
          }
        }
      }

      this.$req
        .post(
          this.$root.$baseapi.iklan + '/iklan/v3/iklan_force_delete',
          formData
        )
        .then(response => {
          this.alasan = '';
          this.dialogHapus = false;
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
          this.selectedAktif = [];
          this.getDataIklan();
          this.getDataIklanDipantau();
          this.getDataIklanIndikasi();
        })
        .catch(error => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
          console.log(responses);
        });
    },
    async go(jenis, item) {
      if (jenis == 'aktif') {
        this.$router.push(
          '/detail-iklan?id=' +
            item._source.id +
            '&judul=' +
            item._source.judul +
            '&jenis=' +
            item._source.jenis
        );
      } else if (jenis == 'beku') {
        this.$router.push(
          '/detail-iklan?id=' +
            item.id_iklan +
            '&judul=' +
            item.judul +
            '&jenis=' +
            item.jenis
        );
      } else if (jenis == 'laporan') {
        this.$router.push(
          '/detail-iklan?id=' +
            item.id_iklan +
            '&judul=' +
            item.judul +
            '&jenis=' +
            item.jenis
        );
      } else if (jenis == 'dipantau') {
        this.$router.push(
          '/detail-iklan?id=' +
            item.id_iklan +
            '&judul=' +
            item.judul +
            '&jenis=' +
            item.jenis
        );
      } else if (jenis == 'semua') {
        this.$router.push(
          '/detail-iklan?id=' +
            item._source.id +
            '&judul=' +
            item._source.judul +
            '&jenis=' +
            item._source.jenis
        );
        // console.log('semua', item)
      }
    },
    async toPantau(item, from) {
      console.log(item);
      this.$router.push(
        '/Detail-pantau?id=' +
          item.id_iklan +
          '&judul=' +
          item.judul +
          '&from=' +
          from
      );
    }
  },
  async created() {
    this.getUser();
    await this.getDataIklanSemua();
    this.getDataIklan();
    this.getDataIklanBeku();
    this.getDataIklanDilaporkan();
    this.getDataIklanDipantau();
    this.getDataIklanIndikasi();
    this.idAdmin = localStorage.getItem('id');
    if (this.$route.query.tab == 'semua') {
      this.tab = 'Semua';
    } else if (this.$route.query.tab == 'aktif') {
      this.tab = 'Aktif';
    } else if (this.$route.query.tab == 'laporan') {
      this.tab = 'Laporan';
    } else if (this.$route.query.tab == 'dipantau') {
      this.tab = 'Dipantau';
    } else if (this.$route.query.tab == 'beku') {
      this.tab = 'Beku';
    } else if (this.$route.query.tab == 'indikasi') {
      this.tab = 'Indikasi';
    }
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  }
};
</script>

<style></style>
